import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useNavigate } from 'react-router-dom';

const PILLARS = [
  {
    icon: 'fa-code',
    color: '#60a5fa',
    title: 'Open Source Movement',
    body: 'At RedRuby Technologies, open source is more than a development model — it is a commitment to innovation, transparency, and community-driven progress. We believe the future of computing will be shaped by collaborative ecosystems and accessible technologies.',
  },
  {
    icon: 'fa-users',
    color: '#34d399',
    title: 'Building with the Community',
    body: 'Our engineering teams are continuous contributors to the Ubuntu and Debian communities, actively supporting and enhancing the Linux ecosystem. We embrace open standards and leverage proven open-source technologies to deliver secure, scalable, and future-ready solutions.',
  },
  {
    icon: 'fa-desktop',
    color: '#a78bfa',
    title: 'Pioneering AI-Powered Linux',
    body: 'RedRuby Technologies has developed multiple desktop-based applications and system components toward building a next-generation AI-enabled Linux OS. By integrating AI directly into the desktop experience, we envision intelligent, privacy-first computing environments for developers, enterprises, and end users.',
  },
];


export const OpenSourceSection = () => {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <div style={{ ...S.section, padding: '70px 0' }}>
      <div className="container">
        <div data-aos="fade-up" style={{ ...S.headerWrap, marginBottom: 0 }}>
          <span style={S.eyebrow}>
            <span style={S.dot} />
            OUR DEVELOPMENT PHILOSOPHY
          </span>
          <h2 style={S.heading}>Code Open. Think Beyond.</h2>
          <p style={S.subheading}>
            Building intelligent Linux ecosystems through continuous open-source
            contributions and AI innovation.
          </p>
          <button onClick={() => navigate('/development-philosophy')} style={S.readMoreBtn}>
            Read More &nbsp;<i className="fa fa-arrow-right" />
          </button>
        </div>
      </div>
    </div>
  );
};

export const OpenSourceFull = () => {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <div style={S.section}>
      <div className="container">
        <div data-aos="fade-up" style={S.headerWrap}>
          <span style={S.eyebrow}>
            <span style={S.dot} />
            OUR DEVELOPMENT PHILOSOPHY
          </span>
          <h2 style={S.heading}>Code Open. Think Beyond.</h2>
          <p style={S.subheading}>
            Building intelligent Linux ecosystems through continuous open-source
            contributions and AI innovation.
          </p>
        </div>

        {/* ── Pillars ── */}
        <div style={S.pillarsGrid}>
          {PILLARS.map(({ icon, color, title, body }, i) => (
            <div key={title} data-aos="fade-up" data-aos-delay={i * 100} style={S.pillarCard}>
              <div style={{ ...S.pillarIconWrap, border: `1.5px solid ${color}44`, background: `${color}18` }}>
                <i className={`fa ${icon}`} style={{ color, fontSize: 20 }} />
              </div>
              <h3 style={{ ...S.pillarTitle, color }}>{title}</h3>
              <p style={S.pillarBody}>{body}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const S = {
  section: {
    backgroundColor: '#2234ae',
    backgroundImage: 'linear-gradient(315deg, #2234ae 0%, #191714 100%)',
    padding: '100px 0',
    color: '#fff',
  },

  /* header */
  headerWrap: {
    textAlign: 'center',
    marginBottom: 56,
  },
  eyebrow: {
    display: 'inline-flex', alignItems: 'center', gap: 8,
    background: 'rgba(255,255,255,0.08)',
    border: '1px solid rgba(255,255,255,0.15)',
    borderRadius: 20, padding: '5px 16px',
    color: '#93c5fd', fontSize: 11, fontWeight: 700, letterSpacing: 1.2,
    marginBottom: 16,
  },
  dot: {
    width: 6, height: 6, borderRadius: '50%',
    background: '#4ade80', boxShadow: '0 0 6px #4ade80',
    display: 'inline-block', flexShrink: 0,
  },
  heading: {
    color: '#fff',
    fontSize: 34,
    fontWeight: 800,
    textTransform: 'uppercase',
    margin: '8px 0 16px',
    lineHeight: 1.2,
  },
  subheading: {
    color: 'rgba(255,255,255,0.75)',
    fontSize: 15.5,
    maxWidth: 520,
    margin: '0 auto',
    lineHeight: 1.75,
  },
  readMoreBtn: {
    marginTop: 32,
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    background: 'rgba(255,255,255,0.12)',
    border: '1.5px solid rgba(255,255,255,0.3)',
    color: '#fff',
    fontSize: 14,
    fontWeight: 700,
    letterSpacing: 0.5,
    padding: '12px 28px',
    borderRadius: 30,
    cursor: 'pointer',
    transition: 'background 0.2s ease',
  },

  /* pillars */
  pillarsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
    gap: 24,
    marginBottom: 52,
  },
  pillarCard: {
    background: 'rgba(255,255,255,0.05)',
    border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: 18,
    padding: '28px 24px',
    backdropFilter: 'blur(6px)',
  },
  pillarIconWrap: {
    width: 52, height: 52, borderRadius: 14,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    marginBottom: 16,
  },
  pillarTitle: {
    fontSize: 19, fontWeight: 600,
    margin: '0 0 10px', lineHeight: 1.3,
  },
  pillarBody: {
    fontSize: 15.5,
    color: 'rgba(255,255,255,0.75)',
    lineHeight: 1.75,
    margin: 0,
  },

};
